export const safetyRolesList = [
  { value: 'rls', label: 'RLS' },
  { value: 'preposto', label: 'Preposto' },
  { value: 'antincendio', label: 'Addetto antincendio' },
  { value: 'primosoccorso', label: 'Addetto primo soccorso' },
  { value: 'dirigente', label: 'Dirigente per la sicurezza' },
  { value: 'rspp', label: 'RSPP' },
  { value: 'aspp', label: 'ASPP' },
  { value: 'altro', label: 'Altro' },
]
